<style lang="less">
@import '../../stylesheet/variable.less';
.home-category-list {
  color: rgb(121, 125, 130);
  background-color: #fff;
  font-size: 14px;
  position: fixed;
  top: 44px;
  z-index: 22;
  font-size: 14px;
  width: 100vw;
  .home-menus-category{
    overflow: scroll;
    padding-right: 40px;
  }
  .home-menus-more{
    background: url('../../image/global/arrow-bg.png');
    position: absolute;
    top: 0;
    right: 0;
    width: 56px;
    text-align: center;
    height: 30px;
    img{
      padding: 11px;
      width: 14px;
      height: 7px;
    }
  }
  .when-show-all{
    transform: scale(1,-1)
  }
  .home-menus-category-all{
    position: absolute;
    top: 0px;
    background-color: rgba(0, 0, 0, 0.6);
    height: 100vh;
    width: 100vw;
    z-index: 1000;
    .category-all-title{
      background-color: #fff;
      padding: 5px 15px;
      img {
        display: block;
        float: right;
        width: 15px;
        height: 7px;
        transform: rotate(180deg);
        margin-top: 6px;
      }
    }
    .category-all-main{
      background-color: #fff;
      padding: 0px 0px 5vw 4vw;
      display: flex;
      flex-wrap: wrap;
      .category-item{
        font-size: 13px;
        height: 30px;
        line-height: 30px;
        width: 20vw;
        text-align: center;
        margin-right: 4vw;
        margin-top: 4vw;
        position: relative;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &::after{
          .setBorderLine(rgb(210,214,220));
        }
      }
      .actived-item{
        color: rgb(192, 49, 49);
        &::after{
          .setBorderLine(rgb(192, 49, 49));
        }
      }
    }

  }
}
</style>
<template>
  <div class="home-category-list" :style="menusStyle|| {}">
    <div class="home-menus-category" v-if="!isShowAllCategory && categoryList.length>1">
      <tab-bar
        ref="tBar"
        :tabtitles="categoryList"
        @changeTab="changeTab"
        className="category-bar"
        :maxTitleNum="4"
        :defaultActiveId="currentId"
        titleWidth="58"
        :defaultStyle="menusStyle"
        >
      </tab-bar>
    </div>
    <div v-show="isNeedShowAll && !isShowAllCategory && categoryList.length>1" :class="['home-menus-more',isShowAllCategory? 'when-show-all' : '']"  @click="toggleList">
      <img src='../../image/home/arrow-down.png'>
    </div>
    <div class="home-menus-category-all" v-show="isShowAllCategory" @touchmove.prevent @click="toggleList">
      <div class="category-all-title" @click.stop="toggleList">
        全部分类
        <img src='../../image/home/arrow-down.png'>
      </div>
      <div class="category-all-main" @click.stop>
        <div
          :class="['category-item', currentId===c.id?'actived-item':'']"
          v-for="c in categoryList"
          :key="c.id"
          @click="changeTabInAll(c.id)"
        >{{c.name}}</div>
      </div>
    </div>
  </div>
</template>
<script>

import icon from './icon'
import tabBar from './menus-tab-bar'

export default {
  props: ['categoryList', 'currentId', 'menusStyle'],
  data() {
    return {
      selected: '',
      isShowAllCategory: false,
    }
  },
  components: {
    icon,
    tabBar,
  },
  mounted() {
    this.selected = this.currentId
  },
  watch: {
    currentId(newVal) {
      this.$nextTick(() => {
        this.$refs.tBar.changeTab(newVal)
      })
    },
    isShowAllCategory(newVal) {
      this.$emit('onShowStateChange', newVal)
    },
  },
  computed: {
    isNeedShowAll() {
      return this.categoryList.length > 4
    },
  },
  methods: {
    changeTab(activeId) {
      if(activeId !== this.currentId) {
        this.$emit('select-change', activeId)
      }
    },
    changeTabInAll(id) {
      this.toggleList()
      setTimeout(() => {
        this.$refs.tBar.changeTab(id)
      }, 0);
    },
    toggleList() {
      this.returnBodyScroll(!this.isShowAllCategory)
      this.isShowAllCategory = !this.isShowAllCategory
    },
    returnBodyScroll(bool) {
      if(bool){
        document.body.style.overflow = "hidden"
      }else{
        document.body.style.overflow = "auto"
      }
    }
  },
}
</script>
